const topics = [
  { title: '偶像团体综艺', desc: '最新偶像团体专属综艺合集', icon: 'ri-star-line', color: 'text-primary-500', bg: 'bg-primary-100' },
  { title: '选秀竞技', desc: '热门选秀节目全程追踪', icon: 'ri-trophy-line', color: 'text-accent-600', bg: 'bg-accent-100' },
  { title: '户外真人秀', desc: '实地挑战趣味无限', icon: 'ri-compass-3-line', color: 'text-secondary-600', bg: 'bg-secondary-100' },
  { title: '音乐舞台', desc: '偶像舞台表演全收录', icon: 'ri-music-line', color: 'text-primary-500', bg: 'bg-primary-100' },
  { title: '恋爱观察', desc: '甜蜜心动真人秀', icon: 'ri-heart-line', color: 'text-accent-600', bg: 'bg-accent-100' },
  { title: '喜剧搞笑', desc: '爆笑综艺轻松一刻', icon: 'ri-emotion-laugh-line', color: 'text-secondary-600', bg: 'bg-secondary-100' },
  { title: '旅行体验', desc: '跟随偶像环游世界', icon: 'ri-earth-line', color: 'text-primary-500', bg: 'bg-primary-100' },
  { title: '生存挑战', desc: '极限环境真实考验', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100' },
  { title: '幕后花絮', desc: '独家探班精彩幕后', icon: 'ri-camera-line', color: 'text-secondary-600', bg: 'bg-secondary-100' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-3">
          热门专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          探索爱豆影视精心整理的综艺专题合集，发现更多精彩内容
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {topics.map((item, i) => (
            <a
              key={i}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex items-start gap-4 p-5 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className={`flex-shrink-0 w-10 h-10 rounded-lg ${item.bg} flex items-center justify-center`}>
                <i className={`${item.icon} ${item.color} text-lg`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors mb-1 whitespace-nowrap">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}